export default __webpack_public_path__ + "static/media/3-Contract-Signing.9a78e94c.jpeg";